import { Show } from 'solid-js';
import type { JSX } from 'solid-js';

export const BusinessInfoInputLabel = (props: { label?: string; required?: boolean; class?: string; description?: JSX.Element }) => (
  <div>
    <div class="mr-1">{props.label}</div>
    <Show when={props.description}>
      <div class="text-xs normal-case text-warning">{props.description}</div>
    </Show>
  </div>
);
